module.exports = __webpack_public_path__ + "img/chica.27923889.png";